<template>
	<div class="image-upload-container">
		<div class="hint">
			<Hint :label="label" :hint="hint"/>
		</div>
		<div class="image-uploader" @dragover.prevent @drop.prevent>
			<input
				class="input-image"
				type="file"
				:accept="allowedFormats.join(', ')"
				v-on:change="uploadImageWithClick"
				ref="imageInput"
			>
			<label
				class="uploader-section"
				@click="$refs.imageInput.click()" v-if="previewUrl.trim() === ''"
				@drop="uploadImageWithDrop"
			>
				<span class="uploader-label">
					<img class="uploader-image" src="@/drc/assets/icons/image-upload.svg" alt="image">
					<span>{{ $t('projectFroms.uploadFile') }}</span>
				</span>
			</label>
			<span :class="['preview', 'large', {'error-border' : errors.length > 0}]" v-if="previewUrl.trim() !== ''">
				<img
					class="close"
					src="@/drc/assets/icons/x-with-cicle.svg"
					width="18"
					height="18"
					alt="close"
					@click="removeImage"
				>
				<img :src="previewUrl" class="preview-image" ref="imagePreview" alt="logo"/>
			</span>
			<div class="image-upload-error" v-if="errors.length > 0">
				<p v-for="(error, index) in errors" :key="index" class="image-error">
					{{ `${$t(`controlPanel.landingPage.errors.${error}`)}` }}
				</p>
			</div>
			<button
				:class="['apply-button', {'error-button' : errors.length > 0 || previewUrl.trim() === ''}]"
				@click="apply"
			>
				{{$t('controlPanel.landingPage.apply')}}
			</button>
		</div>
	</div>
</template>

<script>
import Hint from "@/common/components/Hint";

export default {
	name: "ImageUpload",
	components: {
		Hint
	},
	props: {
		label: {
			type: String,
			required: true
		},
		hint: {
			type: String,
			required: true
		},
		uploadImageWithDrop: {
			type: Function,
			required: true
		},
		uploadImageWithClick: {
			type: Function,
			required: true
		},
		removeImage: {
			type: Function,
			required: true
		},
		apply: {
			type: Function,
			required: true
		},
		allowedFormats: {
			type: Array,
			required: true
		},
		previewUrl: {
			type: String,
			required: true
		},
		errors: {
			type: Array,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.image-upload-container {

	.image-uploader {
		padding-top: 5px;

		.uploader-section {
			padding: 20px 30px;
			background: $color-primary-light;
			width: max-content;
			min-width: 100%;
			min-height: 40vh;
			border-radius: 5px;
			text-align: center;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.uploader-label {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin: 0 auto;

				.uploader-image {
					min-height: 50px;
				}

				span {
					display: block;
					margin-top: 10px;
					color: $light-grey;
					text-decoration: underline;
				}
			}
		}

		.input-image {
			display: none;
		}

		.preview {
			display: inline-block;
			overflow: visible;
			border: 1px solid $light-grey;
			border-radius: 5px;
			padding: 10px;
			position: relative;
			margin-bottom: 0;
			height: fit-content;

			.close {
				position: absolute;
				top: -7.5px;
				right: -7.5px;
				width: 20px;
				height: 20px;
				cursor: pointer;

				&:hover {
					transform: scale(1.1);
				}
			}
		}

		.error-border {
			border: 1px solid $color-red;
		}
	}

	.image-upload-error {
		.image-error {
			color: $color-red;
			margin: 0 auto;
			font-size: 15px;
		}
	}

	.apply-button {
		cursor: pointer;
		background-color: #00E7FF;
		padding: 10px 15px;
		border-radius: 4px;
		border: 1px solid #00E7FF;
		text-transform: uppercase;
		width: fit-content;
		margin-top: 35px;
	}

	.error-button {
		cursor: not-allowed;
		background: $color-grey;
		color: $color-gray-6;
		border: 1px solid $color-grey;
	}
}
</style>
